export const TOTAL_HEADER = 'x-total-count';

export const REQUESTS = {
  PATIENT_PRINTOUT: 'PATIENT_PRINTOUT',
  ABOUT: 'ABOUT',
  GUIDE: 'GUIDE',
  EVENT: 'EVENT',
  FEEDBACK: 'FEEDBACK',
  RESPONSE: 'RESPONSE',
  PRACTITIONER_SPECIALTY: 'PRACTITIONER_SPECIALTY',
  LIST_PROCEDURES: 'LIST_PROCEDURES',
  ADD_BOOKMARK: 'ADD_BOOKMARK',
  REMOVE_BOOKMARK: 'REMOVE_BOOKMARK',
  SET_PROFILE_PRACTITIONER_SPECIALTIES: 'SET_PROFILE_PRACTITIONER_SPECIALTIES'
};

export const UNLISTED_PROCEDURE = {
  score: 0,
  description: 'Other/Unlisted Procedure',
  label: 'Other/Unlisted Procedure',
  procedureEventRate: {},
  procedureFrequency: 0,
  hemorrhageFrequency: null,
  readmissionFrequency: null,
  notHomeFrequency: null,
  procedureRelativeValueUnits: null,
  value: '00000'
};

export const TABS = {
  PROCEDURE: 'procedure',
  DOCUMENTATION: 'documentation',
  RESULTS: 'results',
  PATIENT: 'patient',
  USER_GUIDE: 'guide',
  ABOUT: 'about'
};

export const SPECIALTIES = Object.freeze({
  CARDIAC: 'cardiac',
  GENERAL: 'general',
  GYNECOLOGY: 'gynecology',
  NEURO: 'neuro',
  ORTHOPEDICS: 'orthopedics',
  OTOLARYNGOLOGY: 'otolaryngology',
  PLASTICS: 'plastics',
  THORACIC: 'thoracic',
  UROLOGY: 'urology',
  VASCULAR: 'vascular'
});

export const SPECIALTY_NAMES = Object.freeze({
  [SPECIALTIES.CARDIAC]: 'Cardiac',
  [SPECIALTIES.GENERAL]: 'General surgery',
  [SPECIALTIES.GYNECOLOGY]: 'Gynecology',
  [SPECIALTIES.NEURO]: 'Neurosurgery',
  [SPECIALTIES.ORTHOPEDICS]: 'Orthopedics',
  [SPECIALTIES.OTOLARYNGOLOGY]: 'Otolaryngology (ENT)',
  [SPECIALTIES.PLASTICS]: 'Plastics',
  [SPECIALTIES.THORACIC]: 'Thoracic',
  [SPECIALTIES.UROLOGY]: 'Urology',
  [SPECIALTIES.VASCULAR]: 'Vascular'
});
